<template>
  <div>
    <!-- 标题 -->
    <div class="home obors">
      <h2 class="bt_title">{{title}}</h2>
      <div class="buttonState fr">
        <router-link :to="{path: '/exp/expintro', query:{param:'first'}}" class="btn-blue">指数说明</router-link>
      </div>
    </div>

    <!-- 图表 -->
    <div class="mapbox">
      <div class="bj_white2 home">
        <div class="button mt12 fr pa_z1000">
          <a
            href="javascript:;"
            class="btn-blue"
            :class="{btnhover:measureId === 2}"
            @click="msr_end"
          >终值</a>
          <a
            href="javascript:;"
            class="btn-blue"
            :class="{btnhover:measureId === 1}"
            @click="msr_start"
          >初值</a>
        </div>
        <div class="table_p">
          <div ref="msrLine" id="msrLine" style="margin:0 auto; width:95%; height:100%;"></div>
        </div>
        <p style="padding:0px 25px 10px 0px; font-size:14px;text-align:right">资料来源：宁波航运交易所</p>
      </div>
    </div>

    <!-- 选择框 -->
    <div class="select">
      <div class="screen clearfix">
        <!-- 进出口 -->
        <ul class="fl screen_ul clearfix">
          <li class="fl">
            <strong>进出口类型：</strong>
          </li>
          <el-checkbox-group class="fl" v-model="option">
            <el-checkbox v-for="item in options" :key="item.id" :label="item.name">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </ul>
        <!-- 区域 -->
        <ul class="fl screen_ul clearfix area" v-show="currentId === '1'">
          <li class="fl">
            <strong>区域与国家：</strong>
          </li>
          <el-checkbox-group
            class="fl"
            v-model="area"
            @change="areaChange"
            :disabled="areadisabled"
          >
            <el-checkbox
              v-show="currentId === '1'"
              v-for="item in areas"
              :key="item.id"
              :label="item.label"
            >{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </ul>
        <!-- 水陆运输 -->
        <ul class="fl screen_ul" v-show="currentId === '1'">
          <li class="fl">
            <strong>水路运输：</strong>
          </li>
          <el-radio-group class="fl" v-model="transport" :disabled="tpdisabled">
            <el-radio
              v-for="item in transports"
              :key="item.id"
              :label="item.label"
              @click.native.prevent="clickitem(item.label)"
            >{{item.label}}</el-radio>
            <!--  -->
          </el-radio-group>
        </ul>
        <!-- 时间 -->
        <div class="fl">
          <el-date-picker
            v-model="month"
            value-format="yyyyMM"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :default-value="timeDefaultShow"
            :picker-options="pickerOptions"
            size="small"
          ></el-date-picker>
        </div>
        <div class="button fl">
          <a href="javascript:;" class="btn-blue1" @click="msrSearch">查询</a>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="p10" style="padding: 0px 10px;">
      <div class="home table">
        <div class="button fr">
          <a href="javascript:;" class="btn-blue1" @click="drawChart">作图</a>
        </div>
        <!-- 表 -->
        <my-table v-show="defaultShow" :col="col" :data="data"></my-table>
        <my-table v-show="undefaultShow" :col="cols" :data="datas"></my-table>
        <p style="padding:12px 25px; font-size:14px;text-align:right">资料来源：宁波航运交易所</p>
      </div>
    </div>

    <!-- 画图 -->
    <el-dialog id="chartlog" :visible.sync="chartShow" width="1000px">
      <dtChart ref="mychild" :chartdata="changeChartData"></dtChart>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "@/require/api";
import MyTable from "@/components/MyTable";
import dtChart from "@/components/DrawEcharts";
export default {
  components: {
    MyTable,
    dtChart
  },
  data() {
    return {
      measureId: 2,
      currentId: "",
      title: "",
      // 选项
      option: [],
      options: [
        { id: 2, name: "进出口" },
        { id: 3, name: "进口" },
        { id: 4, name: "出口" }
      ],
      area: [],
      areadisabled: false,
      areas: [
        { id: 20, label: "亚洲" },
        { id: 21, label: "欧洲" },
        { id: 22, label: "非洲" },
        { id: 23, label: "北美洲" },
        { id: 24, label: "拉丁美洲" },
        { id: 25, label: "大洋洲" },
        { id: 26, label: "美国" }
      ],
      transport: [],
      tpdisabled: false,
      transports: [
        { id: 1, label: "总指数" },
        { id: 2, label: "集装箱类" },
        { id: 3, label: "散货类" },
        { id: 4, label: "液货类" }
      ],
      minTime: "",
      maxTime: "",
      month: "",
      timeDefaultShow: "2019",
      pickerOptions: {
        disabledDate: time => {
          this.minTime = "2014-01-31";
          return (
            time.getTime() <= new Date(this.minTime).getTime() ||
            time.getTime() > new Date(this.maxTime).getTime()
          );
        }
      },
      //   表格数据
      col: [],
      cols: [],
      data: [],
      datas: [],
      defaultShow: true,
      undefaultShow: false,
      //   作图
      chartShow: false,
      changeChartData: {
        legend: [],
        xAxis: [],
        series: []
      }
    };
  },
  created() {
    this.getTime();
  },
  methods: {
    // 绘制折线图
    async getMSRLine() {
      const { code, data } = await api.get("/MSRIController/getMSRIInfo", {
        titleId: this.currentId,
        measureId: this.measureId
      });
      let legendData = [];
      let xAxisData = [];
      let yAxisData = [];
      if (code === 0) {
        legendData = data.chartKeys;
        xAxisData = data.xvalues;
        yAxisData = data.series;
        this.drawline(legendData, xAxisData, yAxisData);
      } else {
        legendData = [];
        xAxisData = [];
        yAxisData = [];
        this.drawline(legendData, xAxisData, yAxisData);
      }
    },
    drawline(legendData, xAxisData, yAxisData) {
      let msrLine = this.$echarts.init(document.getElementById("msrLine"));
      msrLine.clear();
      msrLine.setOption({
        grid: {
          left: "3%",
          right: "4%",
          bottom: "6%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#9ca7b0",
              option: 0.3
            }
          }
        },
        legend: {
          data: legendData
        },
        xAxis: {
          type: "category",
          data: xAxisData
        },
        yAxis: {
          type: "value"
        },
        series: yAxisData
      });
      window.onresize = function() {
        msrLine.resize();
      };
    },
    msr_end() {
      this.measureId = 2;
      this.getMSRLine();
    },
    msr_start() {
      this.measureId = 1;
      this.getMSRLine();
    },
    // 选择框
    async getTime() {
      const { code, data } = await api.get("/MSRIController/getMSRITimes");
      if (code === 0) {
        this.minTime =
          data.minTid.toString().substr(0, 4) +
          "-" +
          data.minTid.toString().substr(4, 6);
        this.maxTime =
          data.maxTid.toString().substr(0, 4) +
          "-" +
          data.maxTid.toString().substr(4, 6);
      }
    },
    areaChange() {
      this.area.length !== 0
        ? ((this.areadisabled = false), (this.tpdisabled = true))
        : ((this.areadisabled = false), (this.tpdisabled = false));
    },
    clickitem(e) {
      e === this.transport ? (this.transport = "") : (this.transport = e);
      this.transport
        ? ((this.areadisabled = true), (this.tpdisabled = false))
        : ((this.areadisabled = false), (this.tpdisabled = false));
    },
    // 查询
    msrSearch() {
      if (this.currentId === "1") {
        // 全国
        if (
          this.month &&
          this.option.length !== 0 &&
          (this.area.length !== 0 || this.transport.length !== 0)
        ) {
          this.defaultShow = false;
          this.undefaultShow = true;
          this.getMSRTable();
        } else {
          if (!this.month) {
            this.$message({
              message: "请选择时间",
              type: "warning"
            });
          } else if (this.option.length === 0) {
            this.$message({
              message: "请选择进出口类型",
              type: "warning"
            });
          } else if (this.area.length === 0 || this.transport.length === 0) {
            this.$message({
              message: "请选择区域或者水路运输",
              type: "warning"
            });
          }
        }
      } else if (this.currentId === "2") {
        // 一带一路
        if (this.month && this.option.length !== 0) {
          this.defaultShow = false;
          this.undefaultShow = true;
          this.getMSRTable();
        } else {
          this.$message({
            message: "请填写完整",
            type: "warning"
          });
        }
      }
    },
    // 表格数据
    async getdefaultTable() {
      (this.option = []),
        (this.area = []),
        (this.transport = []),
        (this.month = ""),
        (this.col = []),
        (this.data = []);
      const { code, data } = await api.get("/MSRIController/getMSRIDefTable", {
        titleId: this.currentId
      });
      if (code === 0) {
        this.col = data.col;
        this.data = data.data;
        this.changeChartData.legend = data.seriesText;
        this.changeChartData.xAxis = data.xAxis;
        this.changeChartData.series = data.seriesData;
      }
    },
    async getMSRTable() {
      (this.col = []), (this.data = []);
      const { code, data } = await api.post(
        "/MSRIController/getMSRISelectiveTable",
        {
          titleId: this.currentId,
          indicatorNames:
            this.area.length === 0
              ? this.transport.length === 0
                ? null
                : this.transport.split(",")
              : this.area,
          ioreNames: this.option,
          startTid: this.month[0],
          endTid: this.month[1]
        }
      );
      if (code === 0) {
        this.cols = data.col;
        this.datas = data.data;
        this.changeChartData.legend = data.seriesText;
        this.changeChartData.xAxis = data.xAxis;
        this.changeChartData.series = data.seriesData;
      }
    },
    drawChart() {},
    // 恢复初始值
    oborClear() {
      this.option = [];
      this.area = [];
      this.transport = [];
      this.month = "";
      this.measureId = 2;
      this.defaultShow = true;
      this.undefaultShow = false;
    },
    // 作图
    drawChart() {
      this.chartShow = true;
      if (this.$refs.mychild) {
        this.$refs.mychild.drawLine_Bar(1);
      }
    }
  },
  watch: {
    $route: {
      // $route可以用引号，也可以不用引号  监听的对象
      handler(to, from) {
        this.currentId = to.query.id;
        if (this.currentId === "1") {
          this.title = "海上丝路贸易指数";
        } else if (this.currentId === "2") {
          this.title = '"一带一路"沿线国家贸易指数';
        }
        this.oborClear();
        this.getMSRLine();
        this.getdefaultTable();
      },
      immediate: true // 第一次初始化渲染就可以监听到
    }
    // 点击切换模块高亮样式
    // isHover: {
    //   deep: true,
    //   // immediate: true,
    //   handler: function(newV, oldV) {
    //     this.getMSRLine();
    //     // 选择框的切换
    //     if (newV.isOnhover_q === true) {
    //       this.Trading = true;
    //       this.district = true;
    //       this.move = true;
    //       this.time = true;
    //     } else if (newV.isOnhover_y === true) {
    //       this.Trading = true;
    //       this.district = false;
    //       this.move = false;
    //       this.time = true;
    //     } else if (newV.isOnhover_d === true) {
    //       this.Trading = true;
    //       this.district = true;
    //       this.move = false;
    //       this.time = true;
    //     }
    //   }
    // }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/exp.less";
/deep/.guides {
  display: none !important;
}
.area .el-checkbox-group {
  font-size: 0;
  text-align: left;
}
.obors {
  position: relative;
}
.buttonState {
  position: absolute;
  z-index: 1000;
  right: 20px;
  top: 10px;
}
</style>